import Compressor from 'compressorjs'

export const compressImage = async (image) => {
    const compressedImage = await new Promise((resolve, reject) => {
        new Compressor(image, {
            quality: 0.4,
            success(image){
                resolve(image)
            },
            error(){
                reject()
                return null
            }
        })
    })
    return compressedImage
}